<template>
  <owal-modal-panel
    :title="title"
    :bottom-buttons="buttons"
    presentation-style="form"
    @button-click="handleButton"
  >
    <div class="faces-system-model-detail__container">
      <div class="faces-system-model-detail__accuracy-row">
        <div style="font-weight: bold; padding-right: .5rem;">
          Top One Accuracy:
        </div>{{ ` ${topOne}%` }}
        <div style="font-weight: bold; padding: 0rem .5rem;">
          Top Five Accuracy:
        </div>{{ ` ${topFive}%` }}
      </div>
      <div
        v-if="identities.length > 0"
        class="faces-system-model-detail__identities-list"
      >
        <div
          id="legend"
          class="faces-system-model-detail__identity-card"
        >
          <div
            class="faces-system-model-detail__card-item"
            style="font-weight: bold"
          >
            Name
          </div>
          <div
            class="faces-system-model-detail__card-item"
            style="font-weight: bold"
          >
            Category
          </div>
          <div
            class="faces-system-model-detail__card-item"
            style="font-weight: bold"
          >
            Tag Validation/Training
          </div>
          <div
            class="faces-system-model-detail__card-item"
            style="font-weight: bold"
          >
            F1 Score
          </div>
        </div>
        <div
          v-for="identity in identities"
          :key="identity.uuid"
          class="faces-system-model-detail__identity-card"
        >
          <div class="faces-system-model-detail__card-item">
            {{ `${identity.name}` }}
          </div>
          <div class="faces-system-model-detail__card-item">
            {{ `${identity.category}` }}
          </div>
          <div class="faces-system-model-detail__card-item">
            {{ `V: ${identity.num_tags_validation} T: ${identity.num_tags_training}` }}
          </div>
          <div class="faces-system-model-detail__card-item">
            <div class="faces-system-model-detail__outer-progress-bar">
              <div
                :class="`faces-system-model-detail__inner-progress-bar ${confidenceColor(identity.f1_score)}`"
                :style="`width: ${identity.f1_score * 100}%`"
              >
                <div style="padding-left: 1rem">
                  {{ `${formatF1Score(identity.f1_score)}` }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </owal-modal-panel>
</template>

<script>
import OwalModalPanel from '@/libraries/owal-ui/panels/OwalModalPanel'
import { getDetailsForModel, setNewFacesModel } from '@/libraries/api/faces'

export default {
  name: 'OwalModelDetails',
  components: { OwalModalPanel },
  props: ['domainUUID', 'parsedLabel', 'label', 'topOne', 'topFive', 'modelKey'],
  data () {
    return {
      identities: [],
    }
  },
  computed: {
    title () {
      return `Date created: ${this.parsedLabel}`
    },
    buttons: function () {
      const buttons = [{
        title: 'cancel',
        identifier: 'close',
      },
      {
        title: 'load model',
        identifier: 'select',
      }]

      return buttons
    },
  },
  mounted () {
    getDetailsForModel(this.domainUUID, this.modelKey).then(response => {
      this.identities = response.data.identities
    })
  },
  methods: {
    handleButton: function (identifier) {
      if (identifier === 'close') {
        this.closeWindow(false) // Cancel button
      } else if (identifier === 'select') {
        this.setModel()
      }
    },
    closeWindow: function () {
      this.$emit('close')
    },
    confidenceColor: function (score) {
      // const className = 'faces-system-model-detail__inner-progress-bar'
      if (score > 0.8) {
        return `owal-confidence-green`
      } else if (score > 0.6) {
        return `owal-confidence-yellow`
      } else return `owal-confidence-red`
    },
    formatF1Score (score) {
      let float = parseFloat(score)
      return Math.round(float * 100) / 100
    },
    setModel (modelIndex) {
      setNewFacesModel(this.domainUUID, this.modelKey).then(response => {
        alert('The model was succesfully loaded. Please wait a moment and then refresh the page.')
      }).catch(err => {
        console.log(err)
        alert('There was a problem loading the model. Please contact OWAL so we can check into it.')
      })
    },
  },
}
</script>

<style scoped>
.faces-system-model-detail__container {
  display: flex;
  flex-direction: column;
}

.faces-system-model-detail__accuracy-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.faces-system-model-detail__identities-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: .5rem 0rem;
  justify-content: space-around;
}

.faces-system-model-detail__card-item {
  flex: 1 1 0;
}

.faces-system-model-detail__identity-card {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-bottom: .1rem solid rgb(170, 50, 220, .6);
  padding: .5rem 0rem;
  width: 90%;
}

#legend {
  border-bottom: 0rem ;
}

.faces-system-model-detail__inner-progress-bar {
  border: 0px solid #475669;
  border-radius: 0px;
}

.faces-system-model-detail__outer-progress-bar {
  border: 2px solid #475669;
  width: 100%;
  border-radius: 4px;
}

.owal-confidence-red {
  color: #C0CCDA;
  background: rgba(208,2,27, 1);
}

.owal-confidence-yellow {
  color: #475669;
  background: rgba(255, 243, 108, 1);
}

.owal-confidence-green {
  color: #475669;
  background: rgba(171,213,124, 1);
}

</style>
